import Validator from '@shared/validatorjs/src/validator'
import {
  UpdateLicenseGenerationSettingsRequest,
  UpdateField,
  SetDefaultData,
  FetchLicenseGenerationSettingsRequest,
} from './license-generation-settings.actions'
import { getFormsState } from '../forms/forms.selectors'
import FormTrait from 'src/app/traits/form.trait'
import { getLicenseGenerationSettingsState } from './license-generation-settings.selectors'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { select, Store } from '@ngrx/store'
import { Map } from 'immutable'
import { FetchActiveLayersRequest } from '@shared/shared.actions'
import { getActiveLayers } from '@shared/shared.select'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'app-license-generation',
  templateUrl: './license-generation-settings.component.html',
  styleUrls: ['./license-generation-settings.component.css'],
})
export class LicenseGenerationSettingsComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  public forms: []
  private state$: Subscription
  private formsState$: Subscription
  public isLoading: boolean
  public activeLayersState$: Subscription
  public activeLayers: any[] = []

  constructor(
    public store: Store<any>,
    public translateService: TranslateService,
  ) {
    super()
  }

  ngOnInit() {
    this.store.dispatch(new SetDefaultData('validationErrors'))
    this.store.dispatch(new SetDefaultData('data'))

    this.state$ = this.store
      .pipe(select(getLicenseGenerationSettingsState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })

    this.formsState$ = this.store
      .pipe(select(getFormsState))
      .subscribe((state) => {
        this.forms = state.get('data').toJS()
      })

    this.activeLayersState$ = this.store
      .pipe(select(getActiveLayers))
      .subscribe((state) => {
        if (this.activeLayers.length === 0) {
          this.activeLayers = state.toJS()
        }
      })

    this.store.dispatch(new FetchLicenseGenerationSettingsRequest())
    this.store.dispatch<any>(
      new FetchActiveLayersRequest({
        filters: {},
      }),
    )
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.formsState$.unsubscribe()
    this.activeLayersState$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(
        name || e.target?.name,
        name ? e : e.target?.value,
        'data',
      ),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        '',
      ),
    )
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      SETTINGS_LICENSE_GENERATION_BUSINESS_PATH_LAYER: 'required',
      SETTINGS_LICENSE_GENERATION_RDN_PATH_LAYER: 'required',
      SETTINGS_LICENSE_GENERATION_COMPOUNDS_PATH_LAYER: 'required',
    }
    const validator = new Validator(data.toJS(), rules)

    validator.setAttributeNames({
      SETTINGS_LICENSE_GENERATION_BUSINESS_PATH_LAYER: this.translateService
        .instant('BUSINESS_LICENSE_FOLDER_LAYER')
        .toLowerCase(),
      SETTINGS_LICENSE_GENERATION_RDN_PATH_LAYER: this.translateService
        .instant('RDN_FOLDER_LAYER')
        .toLowerCase(),
      SETTINGS_LICENSE_GENERATION_COMPOUNDS_PATH_LAYER: this.translateService
        .instant('SETTINGS_LICENSE_GENERATION_COMPOUNDS_PATH_LAYER')
        .toLowerCase(),
    })

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()

    const validation = this.validation()
    const { ...payload } = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(
        new UpdateLicenseGenerationSettingsRequest({
          ...payload,
        }),
      )
    } else {
      this.store.dispatch<any>(
        new UpdateField('validationErrors', validation.errors.errors, ''),
      )
    }
  }
}
